import RepositoryManager from '@ComponentsRoot/core/RepositoryManager';
import { OutletContextType } from '@ComponentsRoot/core/types/OutletContextType';

export default class ServicesController {
  viewCtx;
  repositoryManager: RepositoryManager;
  constructor(viewCtx: any, viewProps: { outletContext: OutletContextType }) {
    this.viewCtx = viewCtx;
    this.repositoryManager = viewProps.outletContext.repositoryManager;
  }

  setError = (error: any) => {
    this.viewCtx.setState({ isError: error });
  };

  toggleError = () => {
    this.viewCtx.setState({ isError: null });
  };

  getAllServices = async () => {
    try {
      this.viewCtx.setState({ showSpinner: 'd-block' });
      const res = await this.repositoryManager.getServicesRepository().getAllServices();
      if (res) {
        this.viewCtx.setState({
          showSpinner: 'd-none',
          servicesGridData: res,
        });
      }
    } catch (error) {
      this.viewCtx.setState({ showSpinner: 'd-none' });
      this.setError(error);
      setTimeout(() => {
        this.setError(null);
      }, 5000);
    }
  };

  syncServices = async () => {
    try {
      this.viewCtx.setState({ showSpinnerBtn: 'd-block', disabledBtn: true });
      const res = await this.repositoryManager.getServicesRepository().syncServices(this.viewCtx.props.outletContext.accessToken);
      if (res) {
        const res = await this.repositoryManager.getServicesRepository().getAllServices();
        if (res) {
          this.viewCtx.setState({
            showSpinnerBtn: 'd-none',
            showAlert: true,
            disabledBtn: false,
          });
          setTimeout(() => {
            this.viewCtx.setState({ showAlert: false });
          }, 5000);
          this.viewCtx.setState({ servicesGridData: res });
        }
      }
    } catch (error) {
      this.viewCtx.setState({ showSpinnerBtn: 'd-none', disabledBtn: false });
      this.setError(error);
      setTimeout(() => {
        this.setError(null);
      }, 5000);
    }
  };
}
